import React from 'react';
import ReactDOM from 'react-dom'
import './style.scss';
import PropTypes from "prop-types";
import {FormattedMessage} from 'react-intl';
import cancel from "./cancel.svg"
import brokenImage from "./broken-image.svg"

export default class ProofContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expand: false,
            docUrl: null,
        };
    }

    static propTypes = {
        documents: PropTypes.object.isRequired,
    };

    portalRoot = document.getElementById('root');

    handleImageError = (e) => {
        e.target.alt = "broken"
        e.target.src = brokenImage;
    }

    handleImageLoad = (e) => {
        if(!e.target.src.includes(brokenImage)) {
            e.target.alt = "Proof"
        }
    }

    expandDocument = (e) => {
        this.setState({
            ...this.state,
            expand: true,
            docUrl: e.target.src ||  e.target.children[0].src,
        });
    }

    closeDocument = () => {
        this.setState({
            ...this.state,
            expand: false,
            docUrl: null,
        });
    }

    proofDocument(key, url) {
        return (<div className="Document">
            <div className="Title">
                <FormattedMessage id={`GoSendPartner.${key}`}/>
            </div>
            <div className="ProofWrapper" onClick={this.expandDocument}>
                <img alt="Proof" src={url || ""} onError={this.handleImageError} onLoad={this.handleImageLoad}/>
            </div>
        </div>)
    }

    render() {
        const {expand} = this.state;
        return (
            <>
                <div className="ProofDetails">
                    {this.props.documents["pop"] && this.proofDocument("pop", this.props.documents["pop"])}
                    {this.props.documents["pod"] && this.proofDocument("pod", this.props.documents["pod"])}
                </div>
                {expand && ReactDOM.createPortal(<>
                    <div className="ExpandView">
                        <div className="CancelIcon">
                            <img alt="Cancel" src={cancel} onClick={this.closeDocument}/>
                        </div>
                        <div className="Document">
                            <img alt="Proof" src={this.state.docUrl}/>
                        </div>
                        <div className="Overlay"></div>
                    </div>
                </>, this.portalRoot)}
            </>
        );
    }
}

